import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './Stepper.scss';

const Stepper = ({ steps, currentStep, className = '' }) => (
    <div className={getClassName(styles.stepper, className)}>
        {steps.map((step, index) => (
            <div
                key={step.name}
                className={getClassName(
                    styles.stepper__step,
                    index <= currentStep
                        ? styles['stepper__step--completed']
                        : '',
                    index === currentStep
                        ? styles['stepper__step--active']
                        : '',
                )}
            >
                <div className={styles['stepper__step-label']}>{step.name}</div>
                <div className={styles['stepper__step-indicator']} />
            </div>
        ))}
    </div>
);

export default Stepper;
